export default {
  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      },
    },
  },
};
